module.exports = __webpack_public_path__ + "img/adrienn.4df6086.jpg";